import { render, staticRenderFns } from "./ImageWithPlaceholder.vue?vue&type=template&id=a9c06e02"
import script from "./ImageWithPlaceholder.vue?vue&type=script&lang=js"
export * from "./ImageWithPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports